module.exports = __webpack_public_path__ + "img/parking.32e639b1.svg";